<template>
  <div class="other-resources-wrapper">
    <h2 id="resources" class="resources-title">{{title}}</h2>
    <div class="resources-description" v-html="description"></div>
    <div class="resource-pills">
      <a :href="resource.link" v-for="resource in otherResources" class="resource-pill" rel="external noopener noreferrer" target="_blank" :key="resource.title">
          <div class="resource-title">{{ resource.title }}</div>
      </a>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  data() {
    return {

    };
  },
  methods: {

  },
})

class OtherResources extends Vue {
  @Prop({ type: String })
  title;

  @Prop({ type: String })
  description;

  @Prop({ Array })
  otherResources;
}

export default OtherResources;
</script>

<style lang="scss" scoped>
.other-resources-wrapper {
  width: 100%;
}
.resources-title {
  color: #173945;
}
.resources-description {
  color: #173945;
  font-size: 18px;
  margin-bottom: var(--spacing-l);
  margin-left: auto;
  margin-right: auto;
  margin-top: var(--spacing-xs);
  width: 320px;

  @media only screen and (min-width: 768px) {
    width: 460px; }
  @media only screen and (min-width: 1024px) {
    width: 793px; }
}
.resource-pills {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: var(--spacing-m);

  @media only screen and (min-width: 1024px) {
    width: 900px; }
}
.resource-pill {
  align-items: center;
  border: solid 1px #173945;
  border-radius: 36px;
  background-color: #fff;
  background-image: url(/images/icons/external-link-icon.svg);
  background-origin: content-box;
  background-position: right;
  background-repeat: no-repeat;
  background-size: 12px;
  color: #173945;
  display: flex;
  margin-bottom: 20px;
  margin-left: 8px;
  margin-right: 8px;
  padding: 12px;
  transition: box-shadow 350ms ease-in-out;

  @media only screen and (min-width: 667px) {
    margin-left: 0px;
    margin-right: 6px; }
  @media only screen and (min-width: 1024px) {
    margin-right: var(--spacing-m);
    padding: 12px 24px 12px 24px; }
}
.resource-pill:focus,
.resource-pill:hover,
.resource-pill:focus-visible {
  background-color: #173945;
  background-image: url(/images/icons/external-link-icon-white.svg);
  color: #fff;
  outline: #173945;
}
.resource-title {
  padding-right: var(--spacing-l);
}

</style>
